/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Overview_Stagger_InfoInputs */



/**
* | output |
* | --- |
* | "With {count} players, some sit out each round. Sit-outs rotate: after 3 rounds, everyone has played 2." |
*
* @param {Overview_Stagger_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_stagger_info = /** @type {((inputs: Overview_Stagger_InfoInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Stagger_InfoInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Avec ${i?.count} joueurs, certains ne jouent pas à chaque ronde. Le repos tourne : après 3 rondes, chacun en a joué 2.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Con ${i?.count} jugadores, algunos descansan cada ronda. El descanso rota: tras 3 rondas, todos han jugado 2.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Com ${i?.count} jogadores, alguns ficam de fora a cada rodada. As folgas se revezam: após 3 rodadas, todos jogaram 2.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Con ${i?.count} giocatori, alcuni riposano a ogni round. Il riposo ruota: dopo 3 round, tutti ne hanno giocati 2.`)
	return /** @type {LocalizedString} */ (`With ${i?.count} players, some sit out each round. Sit-outs rotate: after 3 rounds, everyone has played 2.`)
});